import style from '../../../styles/Weather/weather_current_conditions'
import Bottom from './Bottom'
import Top from './Top'

const CurrentConditions = ({ forecast, region }) => {
  return (
    <div className='wrapper'>
      <div className='container-weather'>
        <div className='container-current-conditions'>
          <span className='container-weather-location'>{region}</span>
          <Top forecast={forecast} />
          <Bottom forecast={forecast} />
        </div>
      </div>
      <style jsx>{style}</style>
    </div>
  )
}

export default CurrentConditions
